export default __webpack_public_path__ + "static/media/file-icon.c50c3e3a.svg";